<template>
  <div class="industrial">
      <!-- banner图 -->
      <div class="banner">
        <img src="../../static/img/hzhb_banner@2x.png" alt="">
      </div>
      <!-- 合作伙伴图片 -->
      <ul class="hz_img">
        <li>
          <img src="../../static/img/中国人保@2x.png" alt="">
          <p @click="skip('http://www.epicc.com.cn/')">查看更多</p>
        </li>
        <li>
          <img src="../../static/img/利宝保险@2x.png" alt="">
          <p @click="skip('http://www.libertymutual.com.cn/')">查看更多</p>
        </li>
        <li>
           <img src="../../static/img/鼎和保险@2x.png" alt="">
           <p @click="skip('http://www.edhic.com.cn/')">查看更多</p>
        </li>
        <li>
          <img src="../../static/img/中华保险@2x.png" alt="">
           <p @click="skip('http://www.cic.cn/')">查看更多</p>
        </li>
        <li>
          <img src="../../static/img/大地保险@2x.png" alt="">
           <p @click="skip('http://www.95590.cn')" >查看更多</p>
        </li>
        <li>
           <img src="../../static/img/太平保险@2x.png" alt="">
           <p @click="skip('http://www.cntaiping.com/')">查看更多</p>
        </li>
        <li>
           <img src="../../static/img/安盛天平@2x.png" alt="">
           <p @click="skip('http://www.axatp.com')">查看更多</p>
        </li>
        <li>
           <img src="../../static/img/紫金保险@2x.png" alt="">
           <p @click="skip('http://www.zking.com/')">查看更多</p>
        </li>
        <li>
           <img src="../../static/img/华夏保险@2x.png" alt="">
           <p @click="skip('http://www.ihxlife.com')">查看更多</p>
        </li>
        <li>
           <img src="../../static/img/中国平安@2x.png" alt="">
           <p @click="skip('http://www.pingan.com')">查看更多</p>
        </li>
        <li>
           <img src="../../static/img/众安保险@2x.png" alt="">
           <p @click="skip('https://www.zhongan.com')">查看更多</p>
        </li>
        <li>
           <img src="../../static/img/天安保险@2x.png" alt="">
           <p @click="skip('http://www.95505.com.cn/')">查看更多</p>
        </li>
        <li>
           <img src="../../static/img/华安保险@2x.png" alt="">
           <p @click="skip('https://www.sinosafe.com.cn/')" >查看更多</p>
        </li>
        <li>
           <img src="../../static/img/百年人寿@2x.png" alt="">
           <p @click="skip('http://www.aeonlife.com.cn/')" >查看更多</p>
        </li>
      </ul>
  </div>
</template>

<script>
export default {
  components: {
  },
  data(){
    return{
    }
  },
  methods: {
    skip (url) {
      location.href = url
    },
     isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    }
  },
   mounted () {
    if(this.isMobile()) {
          this.$router.push({ path: "/parnter" });
        } else {
          this.$router.push({ path: "/hzhb?page=5" });
        }
  },
}
</script>
<style lang="scss" scoped>
.cent{
  margin: 0 auto;
  width: 92%;
  }
  .banner {
    width: 100%;
    height: 3.4rem;
    img {
      width: 100%;
      height: 100%;
    }
}
.hz_img{
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding:.3rem;
  li{
    width: 1.6rem;
    height: 2.2rem;
    margin: .35rem;
    position: relative;
    img{
      display: block;
      width: 100%;
      height: 100%;;
    }
    p{
      position: absolute;
      bottom: -.24rem;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      width: 1.1rem;
      height: .4rem;
      line-height: .4rem;
      background-color: #e30f1c;
      font-size: .24rem;
      color: #fffef2;
      border-radius: .16rem;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/Parnter.vue